import { SearchClient } from 'instantsearch.js/es/types'

import { CommonModule } from '@angular/common'
import { InjectionToken, NgModule } from '@angular/core'

import { DebtorService } from '@app-services/debtor/debtor.service'
import { LocalizationService } from '@app-domains/localization/service/localization.service'
import { createSearchClient } from '@app-domains/meilisearch/clients/search-client.factory'
import { PRODUCT_EAN_BROWSE_SOURCE } from '@app-domains/meilisearch/meilisearch.tokens'
import { ContentSearchGatewayService } from '@app-domains/meilisearch/services/content-search-gateway.service'
import { DealerSearchGatewayService } from '@app-domains/meilisearch/services/dealer-search-gateway.service'
import { MeilisearchEanSource } from '@app-domains/meilisearch/services/meilisearch-ean.source'
import { ProductSearchGatewayService } from '@app-domains/meilisearch/services/product-search-gateway.service'
import { InstantsearchConfigureComponent } from '@app-domains/instantsearch/components/configure.component'
import { InstantsearchComponent } from '@app-domains/instantsearch/components/instantsearch.component'
import { InstantsearchStatsComponent } from '@app-domains/instantsearch/components/stats.component'

export const SEARCH_CLIENT = new InjectionToken<SearchClient>('SEARCH_CLIENT')

export function searchClientFactory(
    productGateway: ProductSearchGatewayService,
    contentGateway: ContentSearchGatewayService,
    dealerGateway: DealerSearchGatewayService,
    debtorService: DebtorService,
) {
    return createSearchClient({
        productGateway,
        contentGateway,
        dealerGateway,
        debtorService,
    })
}

export function productEanBrowseSourceFactory(
    gateway: ProductSearchGatewayService,
    localization: LocalizationService,
    debtorService: DebtorService,
): MeilisearchEanSource {
    return new MeilisearchEanSource(gateway, localization, debtorService)
}

@NgModule({
    declarations: [
        InstantsearchConfigureComponent,
        InstantsearchStatsComponent,
        InstantsearchComponent,
    ],
    imports: [CommonModule],
    providers: [
        {
            provide: SEARCH_CLIENT,
            useFactory: searchClientFactory,
            deps: [
                ProductSearchGatewayService,
                ContentSearchGatewayService,
                DealerSearchGatewayService,
                DebtorService,
            ],
        },
        {
            provide: PRODUCT_EAN_BROWSE_SOURCE,
            useFactory: productEanBrowseSourceFactory,
            deps: [ProductSearchGatewayService, LocalizationService, DebtorService],
        },
    ],
    exports: [
        InstantsearchConfigureComponent,
        InstantsearchStatsComponent,
        InstantsearchComponent,
    ],
})
export class InstantsearchModule {}
